import React, { useState } from "react";
import {
  Box,
  Stack,
  Paper,
  TextField,
  InputAdornment,
  SvgIcon,
  Button,
} from "@mui/material";
import { Search as SearchIcon } from "./icons/search";
import IndExamResultModal from "./IndExamResultModal";
import axios from "axios";
import { styled } from "@mui/material/styles";

const Item = styled(Paper)(({ theme, retest }) => ({
  backgroundColor: retest
    ? "rgba(255, 0, 0, 0.5)" // Red background for retests
    : "rgba(203, 243, 240, 0.5)", // Default background color
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  cursor: "pointer",
}));

function ExamResults() {
  const [tutorId, setTutorId] = useState("");
  const [tutorIdError, setTutorIdError] = useState(false);
  const [examResults, setExamResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedTutorId, setSelectedTutorId] = useState("");

  const handleChange = (e) => {
    setExamResults([]);
    const val = e.target.value;
    if (!val || val.length === 0) {
      setTutorIdError(true);
    } else {
      setTutorIdError(false);
    }
    setTutorId(e.target.value);
  };

  const getTutorResults = async () => {
    setExamResults([]);
    try {
      if (!tutorId || tutorId.length === 0) {
        setTutorIdError(true);
        return;
      }
      setTutorIdError(false);
      const val = tutorId;
      const response = await axios.get(
        // `http://localhost:8600/api/admin/get-exam-results-admin/${tutorId}`
        `https://testapis4.el.r.appspot.com/api/tutorWeb/tutoExamInfo/${tutorId}`
      );
      if (response.data.success) {
        setExamResults(response.data.data);
        setSelectedTutorId(val);
        return;
      } else if (response.data.success === false) {
        alert("Please enter correct Tutor id or email");
        setExamResults([]);
        return;
      }
    } catch (err) {
      console.error(err);
      alert("Some error occured. Please try after some time");
      setExamResults([]);
    }
  };

  const handleOpen = (exam_id) => {
    const exam = examResults.find((eachExam) => eachExam.exam_id === exam_id);
    if (!exam) {
      return;
    }
    setSelectedExam(exam);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: "20px 15px",
        width: "100%",
      }}
    >
      <Box>
        <p className="font-Poppins font-normal text-lg">Exam Results</p>
      </Box>
      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
        {tutorIdError ? (
          <TextField
            value={tutorId}
            sx={{ width: "50ch" }}
            error
            label="Please enter Tutor id or email"
            onChange={(e) => handleChange(e)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              ),
              sx: {
                padding: "8px 14px",
              },
            }}
            variant="outlined"
          />
        ) : (
          <TextField
            value={tutorId}
            sx={{ width: "50ch" }}
            onChange={(e) => handleChange(e)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              ),
              sx: {
                padding: "8px 14px",
              },
            }}
            placeholder="Enter Tutor id or email"
            variant="outlined"
          />
        )}
        <Button
          variant="contained"
          color="primary"
          sx={{ marginLeft: "10px" }}
          onClick={getTutorResults}
        >
          Get Results
        </Button>
      </Box>
      <Box sx={{ mt: "15px" }}>
        <Stack flexDirection="row" flexWrap="wrap" gap={2}>
          {examResults.map((eachExam) => (
            <Item
              onClick={() => handleOpen(eachExam.exam_id)}
              retest={eachExam?.retest}
            >
              {eachExam?.subject}
            </Item>
          ))}
        </Stack>
      </Box>
      {open && (
        <IndExamResultModal
          getTutorResults={getTutorResults}
          handleClose={handleClose}
          open={open}
          selectedExam={selectedExam}
          tutorId={selectedTutorId}
        />
      )}
    </Box>
  );
}

export default ExamResults;
